import type { App } from 'vue';
import VueLazyload from 'vue-lazyload';

export function setupLazyload(app: App<Element>) {
  app.use(VueLazyload, {
    preLoad: 1,
    attempt: 1,
    lazyComponent: true,
    observer: true,
  });
}
